import { render, staticRenderFns } from "./DialogText.vue?vue&type=template&id=0a60f3aa&scoped=true"
import script from "./DialogText.vue?vue&type=script&lang=ts"
export * from "./DialogText.vue?vue&type=script&lang=ts"
import style0 from "./DialogText.vue?vue&type=style&index=0&id=0a60f3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60f3aa",
  null
  
)

export default component.exports